import { Component, signal } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { DeviceStatusFormComponent } from '@app/components/forms/device-status/form.component';
import { LoadingErrorBlockComponent } from '@app/components/loading-error-block/loading-error-block.component';
import { HeadMetaComponent } from '@app/components/ui.component';
import { AppHttpError } from '@app/interfaces/pg-models.interface';
import { DeviceStatus, DeviceStatusCreate } from '@app/models/device-status.interface';
import { DeviceStatusHelperService } from '@app/services/helpers/device-status-helper.service';
import { ToastService } from '@app/services/toast.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSave, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { LetDirective } from '@ngrx/component';
import { Observable } from 'rxjs';
import { HelpButtonComponent } from "@app/components/help-button/help-button.component";

@Component({
    selector: 'app-device-status-edit',
    imports: [
        HeadMetaComponent,
        LetDirective,
        LoadingErrorBlockComponent,
        DeviceStatusFormComponent,
        FontAwesomeModule,
        RouterModule,
        HelpButtonComponent
    ],
    templateUrl: './edit.page.html',
    styleUrl: './edit.page.scss'
})
export class DeviceStatusEditPage {
  public title = 'Device Status Edit';
  formValid = signal(false);
  formValue = signal<DeviceStatusCreate | null>(null);
  id: number;
  deviceStatus$: Observable<DeviceStatus>;

  faSave = faSave;
  faArrowLeft = faArrowLeft;

  constructor(
    private route: ActivatedRoute,
    private deviceStatusHelper: DeviceStatusHelperService,
    private router: Router,
    private toast: ToastService,
  ) {
    this.id = this.route.snapshot.params['id'];
    this.deviceStatus$ = this.deviceStatusHelper.getById(this.id);
  }

  update() {
    let val = this.formValue();
    if(val)
      this.deviceStatusHelper.update(this.id, val).subscribe({
        next: (success) => { this.router.navigate(['device-statuses', this.id]); },
        error: (err: AppHttpError) => {
          this.toast.message({ message: err.error.code + ": " + err.error.message, type: 'error'});
        }
      });
  }
}
